"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRipple = void 0;
const createRipple = (event) => {
    const button = event.currentTarget;
    const circle = document.createElement('span');
    const diameter = Math.min(Math.max(button.clientWidth, button.clientHeight), 30);
    const { left, top } = button.getBoundingClientRect();
    const radius = diameter / 2;
    circle.style.width = `${diameter}px`;
    circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - left - radius}px`;
    circle.style.top = `${event.clientY - top - radius}px`;
    circle.classList.add('j-ripple');
    const ripple = button.querySelectorAll('.ripple')[0];
    ripple === null || ripple === void 0 ? void 0 : ripple.remove();
    button.append(circle);
    setTimeout(() => {
        circle === null || circle === void 0 ? void 0 : circle.remove();
    }, 500);
};
exports.createRipple = createRipple;
